import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabs: [{ id: "dashboard", label: "Tableau de bord", path: "/" }], // Onglet par défaut
  activeTab: "dashboard",
  componentCache: {}, // Cache pour préserver l'état des composants (sera un objet avec des Set)
  tabStates: {}, // État spécifique à chaque onglet
};

const tabSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    addTab: (state, action) => {
      const { id, label, path } = action.payload;
      if (!state.tabs.some((tab) => tab.id === id)) {
        state.tabs.push({ id, label, path });
      }
      state.activeTab = id;
    },
    removeTab: (state, action) => {
      const tabId = action.payload;
      state.tabs = state.tabs.filter((tab) => tab.id !== tabId);
      if (state.activeTab === tabId) {
        state.activeTab = state.tabs[0]?.id || "dashboard";
      }
      // Nettoyer le cache et l'état de l'onglet supprimé
      delete state.componentCache[tabId];
      delete state.tabStates[tabId];
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    // Sauvegarder l'état d'un composant
    saveComponentState: (state, action) => {
      const { tabId, componentState } = action.payload;
      if (!state.tabStates[tabId]) {
        state.tabStates[tabId] = {};
      }
      state.tabStates[tabId] = { ...state.tabStates[tabId], ...componentState };
    },
    // Marquer un composant comme mis en cache
    cacheComponent: (state, action) => {
      const { tabId, componentKey } = action.payload;
      if (!state.componentCache[tabId]) {
        state.componentCache[tabId] = new Set();
      }
      state.componentCache[tabId].add(componentKey);
    },
    // Nettoyer le cache d'un onglet
    clearTabCache: (state, action) => {
      const tabId = action.payload;
      delete state.componentCache[tabId];
      delete state.tabStates[tabId];
    },
  },
});

export const { 
  addTab, 
  removeTab, 
  setActiveTab, 
  saveComponentState, 
  cacheComponent, 
  clearTabCache 
} = tabSlice.actions;
export default tabSlice.reducer;
